import TermsOfUseComponent from 'components/marketingSite/termsOfUse/TermsOfUseComponent';
import HeadMetadata from 'components/shared/HeadMetadata';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';

type TermsOfUsePageProps = WithBaseUrl;

const TermsOfUsePage: React.FC<TermsOfUsePageProps> = () => {
  const { t } = useI18n('terms-of-use');

  usePageTrack('Website - Page Loaded');

  return (
    <>
      <HeadMetadata
        url={APP_URLS.termsOfUse}
        title={t('terms-of-use.page_title')}
        desc={t('terms-of-use.page_description')}
      />
      <TermsOfUseComponent />
    </>
  );
};

export default TermsOfUsePage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'terms-of-use'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
